<template lang="pug">
.PopupWorkspace
  .PopupWorkspace-header
    h2 Выберите рабочее пространство
  .PopupWorkspace-close-button
    button.Btn.BtnIcon(
      v-if='$store.getters.workspace',
      @click='closePopup'
    )
      i.Icon.IconClose
  .PopupWorkspace-body.Params
    .Params-field
      switcher(v-model='onlyStable') Скрыть устаревшие рабочие пространства
    .Params-field
      .Params-select(v-if='filteredList.length > 0')
        custom-select#SelectWorkspacePopup_selectWS(
          :options='filteredList',
          v-model='selectedWorkspace',
          :isBoldSelected='true',
          :font-size='12',
          :searchEnabled='filteredList.length > 5',
          optionsIdPrefix='SelectWorkspacePopup_ws_',
          placeholder='Выберите рабочее пространство',
          @opening='handleSelectWorkspaceOpening'
        )
      p(v-else) Нет доступных для выбора рабочих пространств
    .Params-field.IframeCode(v-if='selectedWorkspace && selectedWorkspace.public')
      .Params-label Код интеграции публичного рабочего пространства
      .IframeCode-wrapper
        log(:text='iframeCode')
        button.Btn.BtnIcon(@click='copyIframeCode')
          i.Icon.IconCopy
  .PopupWorkspace-footer
    button#SelectWorkspacePopup_submit.Btn.Btn--blue(
      v-if='filteredList.length > 0',
      @click='selectWorkspace'
    ) Готово
    button#SelectWorkspacePopup_management.Btn.Btn--grey(
      v-if='token && workspaceList.length > 0',
      @click='changeWorkspaceActivations'
    ) Управление пространствами
    button#SelectWorkspacePopup_create.Btn.Btn--grey(
      v-if='token && canCreate',
      @click='createWorkspace'
    ) Создать пространство
    button#SelectWorkspacePopup_logout.Btn.Btn--grey(
      v-if='token && workspaceList.length === 0',
      @click='logout'
    ) Выход
    button#SelectWorkspacePopup_login.Btn.Btn--grey(
      v-if='!token && workspaceList.length === 0',
      @click='login'
    ) Вход
</template>

<script>
import CustomSelect from '@/components/CustomSelect'
import common from '@/mixins/common'
import Log from '@/components/modeling/Log.vue'
import Switcher from '@/components/Switcher.vue'

export default {
  name: 'select-workspace',
  components: {
    CustomSelect,
    Log,
    Switcher
  },
  mixins: [common],
  computed: {
    canCreate() {
      return this.$store.getters.permissions.canCreateWs
    },

    iframeCode() {
      let text = ''
      if (this.selectedWorkspace) {
        text = `<iframe style="min-width: 1024px; min-height: 900px; width: 100%; height: 100%; display: block; border: 0;" src="${window.location.protocol}//${window.location.host}/objects"></iframe>`
      }
      return text
    },
    filteredList() {
      return this.workspaceList
        .filter((v) => !this.onlyStable || v.status === 'stable')
        .map((v) => {
          return {
            ...v,
            name: v.fullName + (v.status === 'broken' ? ' [Устаревшее]' : '')
          }
        })
    },
    workspaceList() {
      return this.token
        ? this.$store.getters.activeWorkspaceList
        : this.$store.getters.activeWorkspaceList.filter((workspace) => {
            return workspace.public
          })
    }
  },
  data() {
    return {
      selectedWorkspace: '',
      onlyStable: false
    }
  },
  mounted() {
    if (!this.filteredList.length) {
      this.getList()
    }
    const index = this.filteredList.findIndex((v) => v.id === this.workspace)
    this.selectedWorkspace = index > -1 ? this.filteredList[index] : ''
  },
  methods: {
    copyIframeCode() {
      navigator.clipboard
        .writeText(this.iframeCode)
        .then(() => {
          this.$ui.toast.show({ text: 'Код интеграции рабочего пространства скопирован в буфер обмена', type: 'success', time: 5000 })
        })
        .catch((err) => {
          this.$ui.toast.show({
            text: 'Ошибка сохранения кода интеграции рабочего пространства в буфере обмена. Выполните операцию самостоятельно, скопировав код выше',
            type: 'error',
            time: 5000
          })
        })
    },
    getList() {
      this.$store.dispatch('getActiveWorkspaces')
    },
    selectWorkspace() {
      if (this.selectedWorkspace) {
        this.$store.commit('setLastOpenedWorkspace', this.selectedWorkspace.id)
      }
      this.$ui.popup.ok()
    },
    changeWorkspaceActivations() {
      this.$ui.popup.ok({ action: 'changeWorkspaceActivations' })
    },
    createWorkspace() {
      if (this.$store.getters.wsLimitReached) {
        this.$ui.toast.show({ text: 'Достигнуто доступное количество версий рабочих пространств.', type: 'error', time: 5000 })
      } else {
        this.$ui.popup.ok({ action: 'createWorkspace' })
      }
    },
    logout() {
      this.$store.dispatch('logout')
      this.$ui.popup.hide()
    },
    login() {
      this.$popupRouter.replace('/login')
      this.$ui.popup.hide()
    },

    /**
     * При открытии выбора рабочего пространство перезапросим список
     * сделано для задачи https://app.clickup.com/t/2r5eakn
     */
    handleSelectWorkspaceOpening() {
      this.getList()
    },

    closePopup() {
      this.$ui.popup.hide()
    }
  }
}
</script>

<style lang="scss">
@import '~base';

.Popup .PopupWorkspace {
  --footerBorder: #{$grey3};
  --valueColor: #{$grey8};
  --textError: #{$red};
}

.Popup[data-theme='dark'] .PopupWorkspace {
  --footerBorder: #{$grey2};
  --textError: #{$red};
}
</style>
<style scoped lang="scss">
@import '~base';

.IframeCode {
  &-wrapper {
    display: flex;

    .Log {
      flex: 1 1 auto;
      margin-right: 15px;
    }

    button {
      flex: 0 0 auto;
    }
  }
}

.PopupWorkspace {
  position: relative;

  &-header {
    padding: 25px 30px 0;

    h2 {
      margin-bottom: 0;
      font-size: 16px;
      text-transform: uppercase;
    }
  }

  &-close-button {
    position: absolute;
    top: 10px;
    right: 15px;

    .Icon {
      font-size: 14px;
    }
  }

  &-body {
    padding: 25px 30px 30px 30px;
  }

  &-footer {
    padding: 5px 30px 10px;
    border-top: 1px solid var(--footerBorder);

    .Btn {
      min-width: 100px;
      font-size: 11px;
      font-weight: 300;
      text-transform: uppercase;
    }

    .Btn + .Btn {
      margin-left: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/SelectWorkspace.vue